import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExpiringLicense = props => {
  if (props.licenses === null) {
    return <div />;
  }

  let expiringLicenses = [];

  props.licenses.forEach(license => {
    if (license.hasExpireWarning || license.hasExpired)
      expiringLicenses.push({
        name: license.name,
        expireDate: license.validTo,
        hasExpireWarning: license.hasExpireWarning,
        hasExpired: license.hasExpired
      });
  });

  if (expiringLicenses.length === 0) {
    return <div />;
  }

  let hasExpiredLicenses =
    expiringLicenses.filter(x => x.hasExpired).length > 0;
  let message = hasExpiredLicenses ? "Utgången licens: " : "Utgående licens: ";

  return (
    <FontAwesomeIcon
      icon="exclamation-triangle"
      className={hasExpiredLicenses ? "text-danger" : "text-warning"}
      title={
        message +
        expiringLicenses
          .map(x => x.name + ": " + moment(x.expireDate).format("YYYY-MM-DD"))
          .join(" | ")
      }
    />
  );
};

export default ExpiringLicense;
